var req = require.context('./', true, /\.js$/);

req([]);
